// KL - personal trainer rates.
const content = {
    slug: 'personal-trainer-rates',
    title: (c) => `Personal Trainer Rates in KL | ${c.money(c.lowest, 0)}-${c.money(c.pt('Elite', 14), 0)} per Session`,
    description: (c) =>
        `Personal trainer rates in Kuala Lumpur: ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session, how they compare with gym PT, and what changes the price.`,
    eyebrow: 'KL · Rates',
    h1: 'Personal Trainer Rates in Kuala Lumpur',
    lead: (c) =>
        `Clear per-session rates instead of a sales pitch at the gym counter. Signature trainers from ${c.money(c.lowest, 0)}, Elite trainers from ${c.money(c.pt('Elite', 50), 0)} a session - no gym membership needed.`,
    image: 'fitness-package2.jpg',
    imageAlt: 'Client and personal trainer working through a session',
    facts: ['Per-session rates', 'No membership needed', 'Instalments on long packages'],
    packagesTitle: 'Package rates',
    sections: [
        {
            title: 'Typical personal trainer rates in KL',
            paragraphs: [
                'In KL, gym-based personal training is often sold in bundles - 10 sessions for around RM1,500 to RM1,600 is common - on top of a monthly membership. Independent and home trainers commonly charge anywhere from RM120 to RM300 a session depending on experience, with travel fees for areas outside the city centre.',
                'Our rates sit at the lower end of that range, with travel included in KL and nearby Klang Valley areas.',
            ],
        },
        {
            title: 'What moves the price',
            tone: 'muted',
            cards: [
                { title: 'Trainer level', body: 'Signature: 2+ years coaching. Elite: 5+ years, often with specialist qualifications.' },
                { title: 'Package size', body: (c) => `${c.money(c.pt('Signature', 14), 0)} per session on 14 sessions vs ${c.money(c.pt('Signature', 50), 0)} on 50.` },
                { title: 'Peak hours', body: (c) => `Before 9am, after 4pm and weekends add ${c.money(c.mods.peak, 0)} a session.` },
                { title: 'Female trainer request', body: (c) => `Adds ${c.money(c.mods.female, 0)} a session.` },
                { title: 'Partner training', body: 'Two people per session, each paying about 70% of the solo rate.' },
                { title: 'Online booking', body: (c) => `Saves ${c.money(c.mods.online, 0)} on every session.` },
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does a personal trainer cost per session in KL?',
            answer: (c) => `${c.money(c.lowest, 0)} to ${c.money(c.pt('Signature', 14), 0)} for Signature trainers and ${c.money(c.pt('Elite', 50), 0)} to ${c.money(c.pt('Elite', 14), 0)} for Elite trainers, depending on package length.`,
        },
        {
            question: 'Is there a transport fee?',
            answer: 'No, within KL and the nearby Klang Valley.',
        },
        {
            question: 'Can I pay by instalment?',
            answer: 'Packages of 30 sessions or more can be split into instalments - ask our team when you book.',
        },
    ],
    schema: { name: 'Personal Trainer Rates in Kuala Lumpur' },
}

export default content
